export default __webpack_public_path__ + "static/media/hippo.c791d1e2.png";